import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const GroupsModalSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const nameLength = t('common.formErrorMessages.name_length');
  const nameRequired = t('common.formErrorMessages.name_required');

  const schema = yup.object({
    name: yup.string().trim().max(50, nameLength).required(nameRequired),
  });

  return schema;
};

export default GroupsModalSchema;
